import React, { useState, useEffect } from "react";
import Popup from "@ecp/common/src/components/modal/Popup";
import Form from "@bo-components/common/form/Form";
import FormField from "@bo-components/common/form/FormField";
import RadioGroup from '@ecp/common/src/components/radio/bo/RadioGroup';
import {UNSAVED_CONFIRM_MESSAGE} from "@bo-pages/system/consts/SystemConsts";
import useEventCallback from "@ecp/common/src/hooks/useEventCallback";
import Input from '@ecp/common/src/components/input/bo/Input';
import PropTypes from "prop-types";
import isEmpty from "lodash-es/isEmpty";
import {FlexBox, FlexBoxColumn} from "@ecp/common/src/layouts/flex/styled";
import {useConfirmDialog} from "@bo-hooks/common/useModal";
import { extractForm } from '@bo-utils/formUtils';
import siteApi from "@bo-apis/system/siteApi";
import useValidate from "@bo-hooks/common/useValidate";
import {TextBox} from "@ecp/common/src/text/TextBox";
import {isValidEmail} from "@ecp/common/src/utils/InputValidateUtils";


const validators = {
  resdEmail: [
    {
      when: ['created', 'updated'],
      message: '대표 메일을 입력해주세요.',
      validator: ({ resdEmail }) =>!isEmpty(resdEmail),
    },
    {
      when: ['created', 'updated'],
      message: '이메일 형식을 확인해주세요.',
      validator: ({ resdEmail }) =>isValidEmail(resdEmail),
    }
  ],
};

const initialErrors = {
  resdEmail: undefined,
  welmallResdEmailUseYn: undefined,
};

const CustomerEmailPopup = ({ open, onClose, siteBasicInfo, welmallCustCenter, refreshResdEmail }) => {
  const [form, setForm] = useState({...initialForm});
  const [hasChangedData, setHasChangedData] = useState(false);
  const [error, setError] = useState({ ...initialErrors });
  const { showConfirmDialog } = useConfirmDialog();
  const { formValidate } = useValidate();

  console.log("welmallCustCenter.resdEmail", welmallCustCenter.resdEmail);
  console.log("siteBasicInfo.resdEmail", siteBasicInfo.resdEmail);

  useEffect(() => {
    if (open) setHasChangedData(false);
    if (open && !isEmpty(siteBasicInfo.resdEmail)) {
      setForm(getFormData(siteBasicInfo));
    } else {
      setForm({ ...initialForm });
    }
  }, [siteBasicInfo, open]);

  const getFormData = ( info ) => ({
    resdEmail: info.resdEmail,
    welmallResdEmailUseYn: (welmallCustCenter.resdEmail === info.resdEmail) ? 'Y' : 'N',
    beforeWelMallResdEmail: welmallCustCenter.resdEmail
  });

  const closePopup = () => {
    if (hasChangedData) {
      showConfirmDialog(UNSAVED_CONFIRM_MESSAGE, onClose);
      return;
    }
    onClose();
  };

  const handleFormChange = useEventCallback((v, data) => {
    setHasChangedData(true);
    setForm((prev) => ({ ...prev, [data.key]: v }));
  });

  const handleResdEmail = async () => {
    let formData = {};
    if (form.welmallResdEmailUseYn === 'Y') {
      console.log("welmallCustCenter", welmallCustCenter);
      formData = getFormData(welmallCustCenter);
    } else {
      const validated = await formValidate('updated', form, setError, validators);
      if (!validated) return;
      formData = Object.keys(form).reduce((prev, key) => {
        if(prev !== undefined && prev !== null) {
          prev[key] = extractForm(form[key]);
          return prev;
        }
      }, {});
    }

    showConfirmDialog('저장하시겠습니까?', () => updateSiteResdEmail(formData));
  };

  const updateSiteResdEmail = async (formData) => {
    await siteApi.updateSiteResdEmail({ ...siteBasicInfo, ...formData });
    refreshResdEmail();
    onClose();
  };

  return (
    <Popup
      type={ 'Medium' }
      open={ open }
      header={ '대표메일수정' }
      onConfirmClick={ handleResdEmail }
      onClose={ closePopup }
      onCancelClick={ closePopup}
      confirmButtonText={ '저장' }
    >
      <Form labelSize={ '120px' }>
        <FormField label= { '구분' } full>
          <RadioGroup
            data-key={'welmallResdEmailUseYn'}
            itemList={diviOptions}
            value={form.welmallResdEmailUseYn}
            onClick={handleFormChange}
          />
        </FormField>
        <FormField label={ '대표 메일' } full>
          { form.welmallResdEmailUseYn === 'Y' ? (
            <TextBox width={ '332px' } style={{whiteSpace: 'pre-wrap' }}>
              { welmallCustCenter.resdEmail }
            </TextBox>
          ) : (
            <>
              <FlexBoxColumn width={'100%'} align-items={'flex-start'}>
                <FlexBox>
                  <Input
                    width={ '332px' }
                    data-key={ 'resdEmail' }
                    value={ form.resdEmail }
                    maxLength={300}
                    error={ !!error.resdEmail }
                    errorMessage={ error.resdEmail }
                    onChange={ handleFormChange }
                    placeholder={ `대표 메일 입력` }
                  />
                </FlexBox>
              </FlexBoxColumn>
            </>
          )}
        </FormField>
      </Form>
    </Popup>
  );
};

export default CustomerEmailPopup;

CustomerEmailPopup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  siteBasicInfo: PropTypes.object,
  welmallCustCenter: PropTypes.object,
  refreshResdEmail: PropTypes.func,

}

export const initialForm = {
  resdEmail: '',
  welmallResdEmailUseYn: 'Y',
  beforeWelMallResdEmail: '',
};

export const diviOptions = [
  { value: 'Y', label: '웰스토리와 동일' },
  { value: 'N', label: '직접입력' },
];
